/* Conexão com o Supabase. As chaves vêm do .env, nunca escritas no código. */
import { createClient } from "@supabase/supabase-js";

const URL  = import.meta.env.VITE_SUPABASE_URL;
const ANON = import.meta.env.VITE_SUPABASE_ANON;

export const configurado = !!(URL && ANON && URL.startsWith("http") && ANON.length > 40);
export const sb = configurado ? createClient(URL, ANON) : null;
export const BUCKET = "documentos";
